import {toastr} from 'react-redux-toastr';
import {
  initialize,
  registerField,
  change,
  formValueSelector
} from 'redux-form';
import {
  getJsonAsync,
  postJsonAsync
} from 'shared/actions';
import {
  setTournamentManagers,
  setTournamentAdministrators,
  toggleTournamentManagerEditing,
  toggleTournamentAdministratorEditing
} from './actionTypes';
import {permissionsFormName} from './constants';
  
export const setupTournamentPermissionsForm = () => (dispatch, getState) => {
  const data = getState().tournament.base.tournamentInfo;
  
  dispatch(initialize(permissionsFormName, {
    ...data 
  }));
};

export const retrieveManagers = tournamentId => dispatch => {
  dispatch(getJsonAsync(`setup/tournament/${tournamentId}/managers`))
  .then(data => dispatch(setTournamentManagers(data)));
};

export const handleManagerAddClick = () => (dispatch, getState) => {
  let managers = getState().tournament.permissions.managers;

  if (!managers) managers = [];

  if (!managers.some(m => { return m.editing; })) {
    managers.push({
      id: null,
      email: '',
      isPrimary: !managers.some(m => { return m.isPrimary; })
    });
  }

  dispatch(setTournamentManagers(managers));
  dispatch(registerField(permissionsFormName, 'tournamentManagerEmail', 'Field'));
  dispatch(change(permissionsFormName, 'tournamentManagerEmail', ''));
  dispatch(toggleTournamentManagerEditing(null));
};

export const handleManagerSaveClick = id => (dispatch, getState) => {
  const tournamentId = getState().tournament.base.tournamentInfo.id;
  const selector = formValueSelector(permissionsFormName);
  const email = selector(getState(), 'tournamentManagerEmail');
  const data = {
    id: id,
    email: email,
    tournamentId: tournamentId
  };
  const promise = postJsonAsync(`setup/tournament/${tournamentId}/manager`, data);

  dispatch(promise)
  .then(response => {
    if (response) toastr.success('Saved!', 'Tournament manager saved successfully.');
    else toastr.error('Not Allowed', 'Email address does not belong to tournament manager role.');
    dispatch(retrieveManagers(tournamentId));
  });
};

export const handleManagerEditClick = (id, email) => dispatch => {
  // We must provide the option to edit the primary manager
  dispatch(registerField(permissionsFormName, 'tournamentManagerEmail', 'Field'));
  dispatch(change(permissionsFormName, 'tournamentManagerEmail', email));
  dispatch(toggleTournamentManagerEditing(id));
};

export const handleManagerCancelClick = () => (dispatch, getState) => {
  const tournamentId = getState().tournament.base.tournamentInfo.id;
  
  dispatch(retrieveManagers(tournamentId));
};

export const handleManagerRemoveClick = id => (dispatch, getState) => {
  const tournamentId = getState().tournament.base.tournamentInfo.id;
  const data = {
    id: id
  };

  dispatch(postJsonAsync(`setup/tournament/${tournamentId}/manager/${id}/remove`, data))
  .then(() => {
    toastr.success('Removed!', 'Tournament manager removed successfully.');
    dispatch(retrieveManagers(tournamentId));
  });
};

export const retrieveAdministrators = tournamentId => dispatch => {
  dispatch(getJsonAsync(`setup/tournament/${tournamentId}/administrators`))
  .then(data => dispatch(setTournamentAdministrators(data)));
};

export const handleAdministratorAddClick = () => (dispatch, getState) => {
  let administrators = getState().tournament.permissions.administrators;

  if (!administrators) administrators = [];

  if (!administrators.some(m => { return m.editing; })) {
    administrators.push({
      id: null,
      email: ''
    });
  }

  dispatch(setTournamentAdministrators(administrators));
  dispatch(registerField(permissionsFormName, 'tournamentAdministratorEmail', 'Field'));
  dispatch(change(permissionsFormName, 'tournamentAdministratorEmail', ''));
  dispatch(toggleTournamentAdministratorEditing(null));
};

export const handleAdministratorSaveClick = id => (dispatch, getState) => {
  const tournamentId = getState().tournament.base.tournamentInfo.id;
  const selector = formValueSelector(permissionsFormName);
  const email = selector(getState(), 'tournamentAdministratorEmail');
  const data = {
    id: id,
    email: email,
    tournamentId: tournamentId
  };

  dispatch(postJsonAsync(`setup/tournament/${tournamentId}/administrator`, data))
  .then(response => {
    if (response) toastr.success('Saved!', 'Tournament administrator saved successfully.');
    else toastr.error('Not Allowed', 'Email address does not belong to tournament administrator role.');
    dispatch(retrieveAdministrators(tournamentId));
  });
};

export const handleAdministratorCancelClick = () => (dispatch, getState) => {
  const tournamentId = getState().tournament.base.tournamentInfo.id;
  
  dispatch(retrieveAdministrators(tournamentId));
};

export const handleAdministratorRemoveClick = id => (dispatch, getState) => {
  const tournamentId = getState().tournament.base.tournamentInfo.id;
  const data = {
    id: id
  };

  dispatch(postJsonAsync(`setup/tournament/${tournamentId}/administrator/${id}/remove`, data))
  .then(() => {
    toastr.success('Removed!', 'Tournament administrator removed successfully.');
    dispatch(retrieveAdministrators(tournamentId));
  });
};


// WEBPACK FOOTER //
// ./src/features/tournament/permissions/actions.js